@if(doShowModal){
    <div class="attachment-view-container">
        @if (isLoading) {
            <app-loading-indicator />
        } 
        @else{
            <div class="attachment-body">
                <button class="button-cancel float-right" type="button" [disabled]="isLoading" (click)="hideModal()">Close</button>
                @if (attachment?.URL) {
                    <a class="button-cancel float-right me-3 text-decoration-none" [href]="attachment?.URL" target="_blank" rel="noopener noreferrer">Open file</a>
                }
                @if(canDelete){
                    <button class="button-delete float-right" type="button" style="margin-right: 15px;" [disabled]="isLoading" (click)="deleteFile()">Delete</button>
                }
                <div class="attachment-content d-flex flex-column align-items-center justify-content-center">
                    @if (isLoadingPDF) {
                        <div class="d-flex align-items-center gap-2 p-3" role="status">
                            <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                            <span>Loading attachment...</span>
                        </div>
                    }
                    @else if (previewLoadFailed) {
                        <p class="p-3" role="alert">The preview could not be loaded. Use Open file to view or download this attachment.</p>
                    }
                    @else if(isPDF) {
                        <div class="att-view-box">
                            <ng2-pdfjs-viewer [pdfSrc]="securePdfUrl ?? ''" [print]="false"
                            [download]="false"
                            [fullScreen]="false"
                            [viewBookmark]="false"
                            [openFile]="false"></ng2-pdfjs-viewer>                           
                        </div>
                    }
                    @else if (attachment?.IsImage) {
                        <div class="image-viewer">
                            <div class="image-viewer__toolbar" aria-label="Image controls">
                                <button type="button" class="button-cancel image-viewer__button" (click)="zoomOut()" [disabled]="imageZoom <= minImageZoom">-</button>
                                <span class="image-viewer__zoom">{{ imageZoom | percent:'1.0-0' }}</span>
                                <button type="button" class="button-cancel image-viewer__button" (click)="zoomIn()" [disabled]="imageZoom >= maxImageZoom">+</button>
                                <button type="button" class="button-cancel image-viewer__button" (click)="resetImageView()">Fit</button>
                            </div>
                            <div
                                class="image-viewer__stage"
                                [class.image-viewer__stage--pan-enabled]="imageZoom > minImageZoom"
                                [class.image-viewer__stage--panning]="isPanningImage"
                                (wheel)="onImageWheel($event)"
                                (pointerdown)="startImagePan($event)"
                                (pointermove)="panImage($event)"
                                (pointerup)="endImagePan($event)"
                                (pointercancel)="endImagePan($event)"
                                (dblclick)="resetImageView()"
                            >
                                <img
                                    class="image-viewer__image"
                                    [src]="attachment?.URL"
                                    (error)="previewLoadFailed = true"
                                    [alt]="attachment?.FileName ?? 'Attachment image'"
                                    [style.transform]="imageTransform"
                                    draggable="false"
                                >
                            </div>
                        </div>
                    }
                    @else {
                        <p class="p-3">A preview is not available for this file. Use Open file to view or download it.</p>
                    }
                    <div class="attachment-file-name">
                        <em><span>{{attachment?.FileName}}</span></em>
                    </div>
                </div>
            </div>
        }
    </div>
}
